const DEFAULT_AUTH_STATE = {
    isAuthenticated: false,
    user: null,
    loading: true,
}

export default DEFAULT_AUTH_STATE;